<template>
  <div class="back">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.back{
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: url('../assets/images/back_back.webp') no-repeat center center;
    background-size: 100% 100%;
}
</style>>